import React from "react"
import ImageShow from "../ImageShow/showImage"
import LinkButtonRed from "../buttons/linkButtonRed/linkButtonRed"
import SectionsTitle from "../../Common/new/SectionsTitle"
import * as style from "./webinarCalendar.module.css"

const HealthCareBanner = ({
  leverageTag,
  comingSoonWebinar,
  leverageTitle,
  leverageDescription,
  keyTakeaways,
  leverageImage,
  leverageKeytakeawayTitle,
  addToCalenderLink,
}) => {
  return (
    <section className={style.webinarcalender}>
      <div className="container">
        <div className={style.calender_wrapper}>
          <div className={style.col_6}>
            <SectionsTitle
              title={leverageTag}
              SubTitle={leverageTitle}
              Content={leverageDescription}
              styleCss={{ display: "none" }}
            />
            <div>
              <div className={style.ul_title}>{leverageKeytakeawayTitle}</div>
              <ul className={style.ul_list}>
                {keyTakeaways.map((items, i) => (
                  <li key={i}>{items.takewayPoint}</li>
                ))}
              </ul>
            </div>
          </div>
          <div className={style.col_6}>
            <div className={style.img_bg}>
              <ImageShow
                imgTagClass={style.quoteImage}
                imageData={
                  leverageImage.mediaItemUrl
                    ? leverageImage.mediaItemUrl
                    : "/images/placeholder-image.jpg"
                }
                // imageData={"/images/placeholder-image.jpg"}
                alt={leverageImage.altText}
              />
              {comingSoonWebinar === "yes" && (
                <LinkButtonRed
                  btnText={addToCalenderLink.title}
                  target={"_blank"}
                  linkTo={addToCalenderLink.url}
                  CustomBtnClass="webinar-calendar-btn m_auto"
                  click={() => { }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HealthCareBanner
